import TempAccChart from './temp-acc-chart.vue';

export default TempAccChart;


// WEBPACK FOOTER //
// ./src/components/_cow-profile/temp-acc-chart/index.js